import BaseCommand from "@/models/api/commands/BaseCommand";

export class OrderItemMoveUpCommand extends BaseCommand {
  CommandName = "OrderItemMoveUp";
  Command: string;
  constructor(sessionId: string, operationId: string, orderItemId: string) {
    super(sessionId, operationId);
    this.Command = orderItemId;
  }
}
